/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignProjectToProgramCommand } from '../../models/assign-project-to-program-command';
import { AssignProjectToProgramCommandResult } from '../../models/assign-project-to-program-command-result';

export interface ApiProjectAssignProjectToProgramPost$Params {
      body?: AssignProjectToProgramCommand
}

export function apiProjectAssignProjectToProgramPost(http: HttpClient, rootUrl: string, params?: ApiProjectAssignProjectToProgramPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProjectToProgramCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectAssignProjectToProgramPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AssignProjectToProgramCommandResult>;
    })
  );
}

apiProjectAssignProjectToProgramPost.PATH = '/api/Project/AssignProjectToProgram';
